import './index.styl';
import template from './index.jst';
import { View } from 'backbone.marionette';
import { Model } from 'backbone';

export class InvalidTeamMessage extends View {
	get template() {
		return template;
	}

	get className() {
		return 'player-popup';
	}

	initialize() {
		this.team = this.getOption('team');

		this.model = new Model({
			is_complete: this.team.complete
		});
	}

	init({ team }) {
		this.model.set({ is_complete: team.complete });
		this.render();

		return this;
	}
}

export default InvalidTeamMessage;